import { WithTooltip } from './WithTooltip';
import Image from './Image';

/**
 * Path to a badge's art in /public. Exported so BadgeAwardedModal renders the
 * same file at its own size without restating the naming convention — the art
 * is only reachable by convention, so a second copy of the template would break
 * silently the first time a badge is renamed.
 */
export const badgeArtSrc = (badgeType) => `/${badgeType}_badge.png`;

export const Badge = ({ badge }) => {
  return (
    <WithTooltip text={badge.name} position='top' anchor='center' showArrow={true}>
      <div className='pb-2'>
        <Image src={badgeArtSrc(badge.type)} alt={badge.name + ' Badge'} className='h-8 w-8' />
      </div>
    </WithTooltip>
  );
};
